"use client";

import { Button } from "@/ui";

export interface CTAClassicProps {
  title?: string;
  subtitle?: string;
  primaryLabel?: string;
  secondaryLabel?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

export default function CTAClassic({
  title = "Ready for your next visit?",
  subtitle = "Reserve your table now and enjoy our chef's signature dishes in an elegant setting.",
  primaryLabel = "Reserve a Table",
  secondaryLabel = "View Menu",
  onPrimaryClick,
  onSecondaryClick,
}: CTAClassicProps) {
  return (
    <section className="max-w-5xl mx-auto text-center px-6">
      <h3 className="text-4xl md:text-5xl font-bold text-black mb-4">
        {title}
      </h3>
      <p className="text-lg md:text-xl text-black/70 mb-8">{subtitle}</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <Button
          type="button"
          variant="primary"
          size="lg"
          onClick={onPrimaryClick}
          className="rounded-full"
        >
          {primaryLabel}
        </Button>
        <Button
          type="button"
          variant="secondary"
          size="lg"
          onClick={onSecondaryClick}
          className="rounded-full"
        >
          {secondaryLabel}
        </Button>
      </div>
    </section>
  );
}
